export const aboutTranslations = {
  fr: {
    hero: {
      title: 'À propos de Stef',
      subtitle: 'Parce que mieux se comprendre change tout.'
    },
    
    story: {
      title: 'Mon histoire',
      intro: 'Je m\'appelle',
      name: 'Stéphanie (Stef) Ruiz',
      role: ', numérologue et coach de vie, spécialisée dans l\'accompagnement personnel, familial et de couple.',
      p1: 'Depuis plus de 20 ans, j\'accompagne les personnes, les couples et les familles dans les périodes de questionnement, de changement ou de difficulté relationnelle.',
      p2: 'Au fil de mon parcours, j\'ai enrichi ma pratique grâce à différentes approches :',
      approaches: 'coaching de vie, accompagnement familial et de couple, numérologie et accompagnement énergétique',
      p3: 'Cette diversité me permet aujourd\'hui de proposer un accompagnement global qui prend en compte la personne dans toutes ses dimensions.',
      p4: 'Je suis convaincue qu\'il est difficile de changer durablement lorsque l\'on ne comprend pas ce qui se joue en profondeur.',
      p5: 'Mon rôle est donc de vous aider à',
      highlight: 'mettre du sens sur ce que vous vivez',
      p5end: 'afin de retrouver plus de clarté, de confiance et de sérénité.',
      quote: 'Mon objectif n\'est pas de vous dire quoi faire mais de vous aider à mieux comprendre qui vous êtes pour avancer de façon plus alignée avec vous-même.'
    },
    
    domains: {
      title: 'Mes domaines d\'accompagnement',
      subtitle: 'Une approche complète pour vous accompagner dans tous les aspects de votre vie',
      numerology: {
        title: 'Numérologie',
        description: 'Comprendre vos potentiels, vos défis et vos cycles de vie.'
      },
      therapy: {
        title: 'Accompagnement de couple et familial',
        description: 'Retrouver le dialogue, apaiser les tensions et renforcer les liens.'
      },
      coaching: {
        title: 'Coaching de vie',
        description: 'Traverser les changements avec plus de clarté et de confiance.'
      },
      energy: {
        title: 'Accompagnement énergétique',
        description: 'Favoriser l\'équilibre émotionnel et le mieux-être.'
      }
    },
    
    values: {
      title: 'Mes valeurs',
      authenticity: {
        title: 'Authenticité',
        description: 'Une présence sincère et bienveillante.'
      },
      empathy: {
        title: 'Empathie',
        description: 'Une écoute profonde et sans jugement.'
      },
      clarity: {
        title: 'Clarté',
        description: 'Mettre du sens sur ce que vous vivez.'
      },
      transformation: {
        title: 'Transformation',
        description: 'Des outils concrets pour avancer durablement.'
      }
    },
    
    cta: {
      title: 'Prêt(e) à faire le point sur votre situation ?',
      subtitle: 'Réservez un appel découverte gratuit de 30 minutes afin d\'échanger sur vos besoins et identifier ensemble l\'accompagnement le plus adapté.',
      button: 'Prendre rendez-vous'
    }
  },
  
  es: {
    hero: {
      title: 'Sobre Stef',
      subtitle: 'Porque comprenderte mejor lo cambia todo.'
    },
    
    story: {
      title: 'Mi historia',
      intro: 'Me llamo',
      name: 'Stéphanie (Stef) Ruiz',
      role: ', numeróloga y coach de vida, especializada en acompañamiento personal, familiar y de pareja.',
      p1: 'Desde hace más de 20 años, acompaño a personas, parejas y familias en períodos de cuestionamiento, cambio o dificultad relacional.',
      p2: 'A lo largo de mi trayectoria, he enriquecido mi práctica gracias a diferentes enfoques:',
      approaches: 'coaching de vida, acompañamiento familiar y de pareja, numerología y acompañamiento energético',
      p3: 'Esta diversidad me permite hoy ofrecer un acompañamiento global que tiene en cuenta a la persona en todas sus dimensiones.',
      p4: 'Estoy convencida de que es difícil cambiar de forma duradera cuando no se comprende lo que está en juego en profundidad.',
      p5: 'Mi papel es ayudarte a',
      highlight: 'dar sentido a lo que vives',
      p5end: 'para recuperar más claridad, confianza y serenidad.',
      quote: 'Mi objetivo no es decirte qué hacer sino ayudarte a comprender mejor quién eres para avanzar de forma más alineada contigo mism@.'
    },
    
    domains: {
      title: 'Mis áreas de acompañamiento',
      subtitle: 'Un enfoque completo para acompañarte en todos los aspectos de tu vida',
      numerology: {
        title: 'Numerología',
        description: 'Comprender tus potenciales, tus desafíos y tus ciclos de vida.'
      },
      therapy: {
        title: 'Acompañamiento de pareja y familiar',
        description: 'Recuperar el diálogo, calmar las tensiones y fortalecer los vínculos.'
      },
      coaching: {
        title: 'Coaching de vida',
        description: 'Atravesar los cambios con más claridad y confianza.'
      },
      energy: {
        title: 'Acompañamiento energético',
        description: 'Favorecer el equilibrio emocional y el bienestar.'
      }
    },
    
    values: {
      title: 'Mis valores',
      authenticity: {
        title: 'Autenticidad',
        description: 'Una presencia sincera y afectuosa.'
      },
      empathy: {
        title: 'Empatía',
        description: 'Una escucha profunda y sin juicio.'
      },
      clarity: {
        title: 'Claridad',
        description: 'Dar sentido a lo que vives.'
      },
      transformation: {
        title: 'Transformación',
        description: 'Herramientas concretas para avanzar de forma duradera.'
      }
    },
    
    cta: {
      title: '¿List@ para hacer un balance de tu situación?',
      subtitle: 'Reserva una llamada descubrimiento gratuita de 30 minutos para hablar de tus necesidades e identificar juntos el acompañamiento más adecuado.',
      button: 'Reservar cita'
    }
  }
};
